import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { productItemMap, translateArr } from '@/data/ecocreditsday';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/ecocredits-day/h5/');

export default function ProductItem() {
    const { locale } = useRouter();
    const { t } = useLang('ecocreditsday.pageTabs.tabC');
    const itemData = productItemMap[locale as keyof typeof productItemMap] || productItemMap.jp;
    const itemList = translateArr(itemData, 2);

    return (
        <div className={styles.productItem}>
            <div className="product-item">
                <div className="product-item__title">{t('product.item_title')}</div>
                <div className="product-item__box">
                    {itemList.map((val: any, i) => (
                        <div className="item-list" key={i}>
                            {val.map((item: Record<string, string | string[]>, index: number) => (
                                <div className="row-item" key={`${i}-${index}`}>
                                    <div
                                        className="item-img"
                                        onClick={() => {
                                            window.open(item.link as string);
                                        }}
                                    >
                                        <EFPic name={item.img} />
                                    </div>
                                    <div className="off">{item.percent}</div>
                                    <div className="detail-content">
                                        {item.isHot && item.isLimit && (
                                            <div className="hot-box">
                                                {item.isHot && <div className="is-hot">{t('product.hot')}</div>}
                                                {item.isLimit && <div className="is-limit">{t('product.num_limit')}</div>}
                                            </div>
                                        )}
                                        {item.nameDesc && <div className="name-desc">{item.h5NameDesc}</div>}
                                        <div className="item-title">{item.name || ''}</div>
                                        <div className="limit-text">{t('product.limit')}</div>
                                        <div className="price-box">
                                            <div>
                                                <span className="base-price">{`${t('product.unit')}${item.limitPrice || 0}`}</span>
                                                <span className="taxes-base">{t('product.taxes')}</span>
                                            </div>
                                            <div>
                                                <span className="limit-price">{`${t('product.unit')}${item.price || 0}`}</span>
                                                <span className="taxes-limit">{t('product.taxes')}</span>
                                            </div>
                                        </div>
                                        <div className="desc">{item.desc}</div>
                                        <div className="link-btn">
                                            <div
                                                className="link-common left-link"
                                                onClick={() => {
                                                    window.open(item.link as string);
                                                }}
                                            >
                                                <div className="link-svg"></div>
                                                <div className="left-link__text">{t('product.btn1')}</div>
                                            </div>
                                            <div
                                                className="link-common right-link"
                                                onClick={() => {
                                                    const url = `https://jp.ecoflow.com/cart/${item.productId}:1?channel=buy_button`;
                                                    window.open(url);
                                                }}
                                            >
                                                {t('product.btn2')}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
